// src/frontend/index.tsx
import { createRoot } from 'react-dom/client';
import AuthWrapper from './components/AuthWrapper';
import './styles/frontend.scss';

// Initialize the floating button
const initFloatingButton = () => {
  const container = document.getElementById('kalicube-toolbox-button');
  if (container) {
    const root = createRoot(container);
    root.render(<AuthWrapper />);
  }
};

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
  initFloatingButton();
});